import { render } from "./Module.vue?vue&type=template&id=155e2ab3"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__